<template>
  <div class="">
    <div v-for="(value, index) in values" v-if="values.length > 0" :class="{ 'tw-mt-4': index > 0}" class="tw-flex">
      <input :name="nameOfTable + '[' + index + '][id]'" :value="value.id" type="hidden">

      <div class="tw-w-64">
        <bordered-input>
          <template #label>
            <label :for="nameOfTable + '_' + nameOfValue + '_' + index">
              {{ valueLabel }}
            </label>
          </template>
          <template #input>
            <input v-if="!options" :id="nameOfTable + '_' + nameOfValue + '_' + index" v-model="value[nameOfValue]"
                   :name="nameOfTable + '[' + index + '][' + nameOfValue + ']'" :placeholder="valuePlaceholder"
                   :type="inputType" @change="handleChange">
            <select v-if="options" :id="nameOfValue + '_' + index" v-model="value[nameOfValue]" :name="nameOfTable + '[' + index + '][' + nameOfValue + ']'"
                    class="tw-mr-6" @change="handleChange">
              <option v-if="!value[nameOfValue]" selected value=''>
                {{ emptyOptionName }}
              </option>

              <option v-for="(option, index) in options" :selected="value[nameOfValue] == option.id" :value="option.id">
                {{ option.name }}
              </option>
            </select>
          </template>
        </bordered-input>
      </div>

      <div class="tw-ml-2">
        <bordered-input>
          <template #label>
            <label :for="nameOfTable + '_valid_from_' + index">
              Gültig ab
            </label>
          </template>
          <template #input>
            <input :id="nameOfTable + '_valid_from_' + index" v-model="value.valid_from" :name="nameOfTable + '[' + index + '][valid_from]'"
                   class="tw-mr-4" placeholder="Gültig ab" type="date"
                   @change="handleChange">
          </template>
        </bordered-input>
      </div>

      <button class="cu-btn-default tw-ml-2" type="button" @click="$event => addValue(index)">
        <i class="fa fa-plus"></i>
      </button>

      <button class="cu-btn-default tw-ml-2" type="button" @click="removeValue(index)">
        <i class="fa fa-trash-o"></i>
      </button>
    </div>
    <div v-if="values.length === 0">
      <button class="cu-btn-default" type="button" @click="addValue(-1)">
        <i class="fa fa-plus"></i>
        {{ submitText }}
      </button>
    </div>
  </div>
</template>

<script>
import BorderedInput from "./BorderedInput";
import moment from 'moment';

export default {
  components: {
    BorderedInput,
  },

  props: {
    inputType: {
      required: false,
      default: 'text',
      type: String
    },

    initialValues: {
      required: false,
      default: null,
      type: Array,
    },

    // for example "vacationDays"
    nameOfValue: {
      required: true,
      type: String,
    },

    // for example "vacation_days"
    nameOfTable: {
      required: true,
      type: String,
    },

    // for example "Urlaub"
    valuePlaceholder: {
      required: true,
      type: String,
    },

    // for example "Urlaub eintragen"
    submitText: {
      required: true,
      type: String,
    },

    // for example "Urlaub"
    valueLabel: {
      required: true,
      type: String,
    },

    // show options instead of input
    options: {
      type: Array // [{"id": "2", "name": "test"}]
    },

    emptyOptionName: {
      required: false,
      type: String,
      default: 'No option chosen',
    },

    // name of function to handle
    handleNewCurrent: {
      required: false,
      type: String,
      default: null,
    },
  },

  data() {
    return {
      values: [],
    }
  },

  methods: {
    addValue(index) {
      let newVal = {
        id: null,
        valid_from: index == -1 ?
            moment().format('YYYY-MM-DD') :
            moment(this.values[index].valid_from).add(1, 'days').format('YYYY-MM-DD'),
      };
      newVal[this.nameOfValue] = '';
      this.values.splice(index + 1, 0, newVal);
      this.handleChange();
    },

    removeValue(index) {
      this.values.splice(index, 1);
      this.handleChange();
    },

    handleChange() {
      if (this.handleNewCurrent !== null) {
        let current = null;
        this.values.forEach((value) => {
          if (current === null ||
              (!moment(value.valid_from).isAfter(moment()) && moment(value.valid_from).isAfter(moment(current.valid_from)))) {
            current = value;
          }
        });
        jsHandleVueChange(this.handleNewCurrent, current);
      }
    },
  },

  mounted() {
    if (this.initialValues.length > 0) {
      this.initialValues.forEach(item => {
        let newVal = {
          id: item.id,
          valid_from: item.valid_from ?
              moment(item.valid_from).format('YYYY-MM-DD') :
              moment().format('YYYY-MM-DD'),
        };
        newVal[this.nameOfValue] = item[this.nameOfValue];
        this.values.push(newVal);
      });
      // thanks to 'YYYY-MM-DD' sorting like strings works
      this.values.sort((a, b) => {
        return moment(a.valid_from).diff(moment(b.valid_from));
      });
    }
  }
}
</script>